// extracted by mini-css-extract-plugin
module.exports = {"skill_div_main":"Skills_skill_div_main__1eEnQ","skill_div":"Skills_skill_div__3eEmv","icon_description":"Skills_icon_description__1h657","icon_div":"Skills_icon_div__9GEKB"};